import { useContext, useEffect, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import accuracyImage from "../../assets/accuracy.png";
import changesImage from "../../assets/changes.png";
import gaugeImage from "../../assets/gauge.png";
import historyImage from "../../assets/history.png";
import toptenImage from "../../assets/topten.png";
import { ChartsDataContext } from "../../contexts/chartsData";
import { IntroductionContext } from "../../contexts/introduction";
import { Accordion } from "./accordion";
import "./guide.css";

function getPageContent(result, title) {
  return (
    result.find((page) => page?.page_title?.trim() === title.trim())
      ?.page_content || "<p></p>"
  );
}

export function Guide({}) {
  const { value: chartsData } = useContext(ChartsDataContext);
  const { value: introductionData } = useContext(IntroductionContext);
  const [guides, setGuides] = useState([]);
  const [note, setNote] = useState("<p></p>");
  const [about, setAbout] = useState("<p></p>");
  const [contactUs, setContactUs] = useState("<p></p>");
  const [address, setAddress] = useState("<p></p>");

  useEffect(() => {
    if (!Array.isArray(chartsData)) return;

    setGuides(
      chartsData.map((item) => ({
        title: item?.title || null,
        content: item?.content || null,
        image: item?.image || null,
      }))
    );
  }, [chartsData]);

  useEffect(() => {
    if (!Array.isArray(introductionData)) return;

    setNote(getPageContent(introductionData, "Introduction"));
    setAbout(getPageContent(introductionData, "About"));
    setContactUs(getPageContent(introductionData, "ContactUs"));
    setAddress(getPageContent(introductionData, "Address"));
  }, [introductionData]);

  return (
    <Container>
      <Row>
        <Col md={12}>
          <div
            className="note-wrapper"
            dangerouslySetInnerHTML={{
              __html: note,
            }}
          ></div>
        </Col>
        <Col md={12}>
          {guides.map((item, index) => (
            <Accordion
              key={"guide" + index}
              isOpen={index === 0}
              image={item?.image || ""}
              title={item?.title || ""}
              content={item?.content || ""}
            />
          ))}
        </Col>
        <Col md={12} className="footer-wrapper">
          <Row className="bg-blue footer">
            <Col md={4}>
              <div
                dangerouslySetInnerHTML={{
                  __html: about,
                }}
              ></div>
            </Col>
            <Col md={4}>
              <div
                dangerouslySetInnerHTML={{
                  __html: contactUs,
                }}
              ></div>
            </Col>
            <Col md={4}>
              <div
                dangerouslySetInnerHTML={{
                  __html: address,
                }}
              ></div>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default Guide;
